// extracted by mini-css-extract-plugin
export default {"animate-spin-reverse":"components-billing-admins-cells-td-actions-module__animate-spin-reverse","spin-reverse":"components-billing-admins-cells-td-actions-module__spin-reverse"};